import React, { useEffect, useState, Fragment} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Container, Row, Col, Form, Button} from 'react-bootstrap'
import {useFormik} from 'formik'
import { validationSchemas } from '../../common/validation-Schemas-informes'
import { obtenerEstados, obtenerCriteriosFecha, obtenerInformesPrevios, generarInforme, obtenerGestores} from '../../store/actions/informes-profesionales-action'
import { Auth, LoadingComponent } from 'recupero-comunes'

const FiltrosInforme = () => {
    const [loading, setLoading]=useState(false)
    const data_informes = useSelector((state) => state.informesProfesionalesReducer)
    const { cfg_formInf, tiposInforme, gestores, estados, responsables, criteriosFecha, respuestaGenerar} = data_informes
    const {rutUsuario, rutOrganizacion} = Auth.currentUser()
    const dispatch = useDispatch()
    const [tipoGestion, setTipoGestion]=useState(null)
    const TIPO_INFORME_RAT = 299002;
    const TIPO_INFORME_INFORMES_PROFESIONALES = 282004;
    const [isDias, setIsDias]=useState(false)
    const [isFechas, setIsfechas]=useState(false)

    const formik = useFormik({
        initialValues: {
          "rutcia": '',
          "rutusr":'',
          "tipoInforme": '',
          "gestor": '',
          "estado": '', 
          "responsable": '', 
          "fechadesde": '',
          "fechahasta": '', 
          "criterioFecha": ''
        },
        validationSchema: validationSchemas(isDias, isFechas),
        onSubmit: (formData) => {
            setLoading(true)
            const dataForm = {};// {...formData}

            dataForm['rutcia'] = rutOrganizacion && rutOrganizacion
            dataForm['rutusr'] = rutUsuario && rutUsuario     
            dataForm['tipoInforme'] = {id: TIPO_INFORME_INFORMES_PROFESIONALES, glosa:'Informes Profesionales'}; //Por defecto
            dataForm['tipoInformeProf'] = formData.tipoInforme ? {id: formData.tipoInforme, glosa: tiposInforme.find(element => element.id == formData.tipoInforme).nombre} : {};       
            dataForm['gestor'] = formData.gestor ? {id: formData.gestor, glosa: gestores.find(element => element.id == formData.gestor).nombre} : {};       
            dataForm['estado'] = formData.estado ? {id: formData.estado, glosa: estados.find(element => element.id == formData.estado).nombre} : {};       
            dataForm['responsable'] = formData.responsable ? {id: formData.responsable, glosa: responsables.find(element => element.id == formData.responsable).nombre} : {};       
            dataForm['fechadesde'] = formData.fechadesde;
            dataForm['fechahasta'] = formData.fechahasta;
            dataForm['criteriosFecha'] = formData.criterioFecha ? {id: formData.criterioFecha, glosa: criteriosFecha.find(element => element.id == formData.criterioFecha).nombre} : {};       
          
            console.log("dataForm: ", dataForm);
            try {
                dispatch(generarInforme(dataForm))
                .then(() => {
                    let query = Buffer.from(JSON.stringify({'rutcia': rutOrganizacion && rutOrganizacion, 'rutusr': rutUsuario && rutUsuario})).toString('base64')  
                    dispatch(obtenerInformesPrevios(query));
                })
                .then(()=>setLoading(false))
            } catch (error) {
                setLoading(false)
                console.log("error: ", error);
            }

        }
    })
    useEffect(() => {
        let excel = respuestaGenerar && respuestaGenerar.respuestaGenerar.object;
        console.log("excel: ", excel);
        if (excel) {

            setLoading(false);
            
            var link = document.createElement("a");
            link.download = excel.filename;
            link.href = "data:" + excel.mimetype + ";base64," + excel.xlsxfile;
            link.click();
        }

    }, [respuestaGenerar]);

    const handleLimpliar=()=>{
        formik.resetForm();
        setIsDias(false);
        setIsfechas(false);
    }
    const handleChangeTipoInforme=(tipoInforme)=>{
        let tg = "235001"; //Recupero
        if (tipoInforme == 282002)  {
            tg = "235005"; //Defensa
        }
        setTipoGestion(tg);
        let query = Buffer.from(JSON.stringify({concepto: 300})).toString('base64')
        dispatch(obtenerEstados(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({rutcia: rutOrganizacion, concepto: 303})).toString('base64')
            dispatch(obtenerCriteriosFecha(query))
        })
        .then(()=>{
            let rol = "70GESINFMED";
            if (tipoInforme == TIPO_INFORME_RAT) {
                rol = "70GESINFRAT";
            }
            console.log("rol: ", rol);
            let query = Buffer.from(JSON.stringify({ idOrganizacion: rutOrganizacion, rol: rol, tipoPersona: '0080PROVE00' })).toString('base64');
            dispatch(obtenerGestores(query))
        })
    }
    return (      
    <>
      <style type='text/css'>
        {`
        .btn-limpiar {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;
            
        }
        .btn-buscar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
      
          }
        `}
        </style>
        <LoadingComponent show={loading}/>
        <Form onSubmit={formik.handleSubmit}>
        <Container>
            <Container>            
            {cfg_formInf? (
                <div >                  
                    <Row >                 
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf['informes-prof-filtro-tipo-informe'] : "Tipo Informe"}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    //setTipoGestion(e.target.value == 282001 ? 235001 : 235005);
                                    handleChangeTipoInforme(e.target.value);
                                }}
                                name='tipoInforme'
                                value={(formik.values.tipoInforme)}
                                error={formik.errors.tipoInforme}
                            >
                            <option value={''}>Seleccione...</option>
                            {tiposInforme &&
                                tiposInforme?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.tipoInforme ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.tipoInforme}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>                
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-prof-filtro-gestor']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)

                                }}
                                name='gestor'
                                value={(formik.values.gestor)}
                                error={formik.errors.gestor}
                            >
                            <option value={''}>Seleccione...</option>
                            {gestores &&
                                gestores?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.gestor ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.gestor}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                        <Col md='4'>
                            <Form.Label className='mb-2 mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-prof-filtro-responsable']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                className='mt-2'
                                aria-label='Default select example'
                                onChange={(e) => {
                                    formik.handleChange(e)

                                }}
                                name='responsable'
                                value={(formik.values.responsable)}
                                error={formik.errors.responsable}
                            >
                            <option value={''}>Seleccione...</option>
                            {responsables &&
                                responsables?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.responsable ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.responsable}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                    </Row>
                    <Row >                 
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-4'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-prof-filtro-estado']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select                            
                                onChange={(e) => {
                                    formik.handleChange(e)

                                }}
                                name='estado'
                                value={(formik.values.estado)}
                                error={formik.errors.estado}
                            >
                            <option value={''}>Seleccione...</option>
                            {estados && estados
                                ?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.estado ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.estado}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                        <Col md='2'>
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-prof-filtro-fecha-desde']}
                            </Form.Label>{' '}
                            <br />                   
                            <Form.Control type='date'
                                name='fechadesde'
                                value={formik.values.fechadesde}
                                onChange={(e)=>{
                                    formik.handleChange(e)     
                                    setIsfechas(true);  
                                }}
                            ></Form.Control>                
                        </Col>
                        <Col md='2' >
                            <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-prof-filtro-fecha-hasta']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Control type='date'
                                name='fechahasta'
                                value={formik.values.fechahasta}
                                onChange={(e)=>{
                                    formik.handleChange(e)
                                    setIsfechas(true);  
                                }}
                            ></Form.Control>
                        </Col>
                        <Col md='3'>
                            <Form.Label className='mb-2 mt-4'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                {cfg_formInf.cfg_formInf && cfg_formInf.cfg_formInf['informes-prof-filtro-criterio-fecha']}
                            </Form.Label>{' '}
                            <br />
                            <Form.Select
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    setIsfechas(true);  
                                }}
                                name='criterioFecha'
                                value={(formik.values.criterioFecha)}
                                error={formik.errors.criterioFecha}
                            >
                            <option value={''}>Seleccione...</option>
                            {criteriosFecha && criteriosFecha
                                ?.filter(p => (p.agrupacion == 0 || p.agrupacion == tipoGestion))
                                ?.map((c) => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))
                            }
                            </Form.Select>
                            {formik.errors.criterioFecha ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.criterioFecha}
                                </Form.Text>
                            ) : (
                                ''
                            )} 
                        </Col>
                
                    </Row>
                    <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                    <Row className='mt-2'>                            
                        <Col className='d-flex align-items-end justify-content-end m-2'>
                            <Button className='m-2' variant='limpiar' onClick={handleLimpliar}  >
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf["informes-prof-filtro-btn-limpiar"] : "Limpiar"}
                            </Button>
                            <Button className='m-2' variant='buscar' type='onSubmit' >
                                {cfg_formInf.cfg_formInf ? cfg_formInf.cfg_formInf["informes-prof-filtro-btn-gen-informe"] : "Generar Informe"}
                            </Button>                            
                        </Col>
                    </Row>
                </div>
            ) : ""}
            </Container>
        </Container>
        </Form>
    </>
  )
}
export default FiltrosInforme 